export const minXXS = 360;
export const minXS = 480;
export const minSM = 640;
export const minMD = 768;
export const minLG = 1024;
export const minXL = 1280;
export const minXXL = 1920;

export const bpMinXS = `@media (min-width: ${minXS}px)`;
export const bpMinSM = `@media (min-width: ${minSM}px)`;
export const bpMinMD = `@media (min-width: ${minMD}px)`;
export const bpMinLG = `@media (min-width: ${minLG}px)`;
export const bpMinXL = `@media (min-width: ${minXL}px)`;
export const bpMinXXL = `@media (min-width: ${minXXL}px)`;

export const bpMaxXXXS = `@media (max-width: ${minXXS - 1}px)`;
export const bpMaxXXS = `@media (max-width: ${minXS - 1}px)`;
export const bpMaxXS = `@media (max-width: ${minSM - 1}px)`;
export const bpMaxSM = `@media (max-width: ${minMD - 1}px)`;
export const bpMaxMD = `@media (max-width: ${minLG - 1}px)`;
export const bpMaxLG = `@media (max-width: ${minXL - 1}px)`;
